import { CellAction, CellBottomPart } from '@components/ui/Table/utils';
import { UserRoles, Permissions } from '@hooks/users/types';
import useAuthStore from '@store/authStore';
import { formatDate, hasPermission } from '@utils/index';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { CircleRightArrow, WarningCircleIcon } from '@cloudclevr/components';
import useModalStore from '@store/modal';

export const createCellValue = (
  property: keyof any,
  data: any[],
  index: number,
  isMobile: boolean,
  formattedValue: string,
  isHiddenProperty = false
) => {
  const value = data[index][property];
  const userRole = useAuthStore.getState().role || UserRoles.STANDARD;
  const modalStore = useModalStore.getState();

  const seePeopleDetailsHasPermission = hasPermission(
    userRole,
    Permissions.SUPERADMIN_ADMIN
  );

  switch (property) {
    case 'fullName':
      return (
        <>
          <span className="flex items-center">
            {value as string}{' '}
            {seePeopleDetailsHasPermission && !isHiddenProperty && (
              <Link
                className="ml-2 mt-[3px] cursor-pointer"
                to={`/accounts/accounts/account/${data[index]['accountId']}`}
              >
                <CircleRightArrow size="4" />
              </Link>
            )}
          </span>
          {!isMobile && <CellBottomPart data={data[index]['emailAddress'] || data[index]['email']} />}
        </>
      );
    case 'eventTypes': {
      const events = data[index]['eventTypes'];
      return (
        !isHiddenProperty && (
          events.length > 1 ? (
            <>
              <span>{events.length} types</span>
              <div className="flex flex-row items-center">
                <CellBottomPart data={`View detail`} />
                <CellAction index={index} isVideoFormat={true} />
              </div>
            </>) :
            <div className='cursor-pointer flex flex-row gap-2 justify-start align-center' onClick={() => {
              modalStore.setIsDetailsModalOpen(true);
              modalStore.setModalTitle(events[0].eventType)
            }}>
              <span>{events[0].eventType}</span>
              <WarningCircleIcon color={'#7D848A'} classNames="h-4 w-4 mt-1" />
            </div>

        )
      );
    }
    case 'eventCounts':
    case 'eventCount':
      return (
        <>
          <span>{value as string}</span>
        </>
      );
    case 'latestEventDateTime':
    case 'dateTime':
      return typeof value === 'string' ? (
        <>
          <span>{formatDate(value)}</span>
          <CellBottomPart data={dayjs(value).format('HH:mm:ss')} />
        </>
      ) : (
        <span></span>
      );
  }
};

export const getSuspiciousActivityURL = (name: string) =>
  `https://cdn.clevr360.com/assurance/${name.replaceAll(' ', '-')}.html`